const d = (t, n) => {
  if (!t || !window) return;
  const o = t.startsWith("data:image") ? t : `data:image/png;base64,${t}`, e = document.createElement("a");
  e.href = o, e.download = n || `${Date.now()}-image.png`, document.body.appendChild(e), e.click(), document.body.removeChild(e);
};
export {
  d as default
};
